import { useEffect, useState } from 'react'
import ArrowForwardCircle from 'react-ionicons/lib/ArrowForwardCircle'
import CloseCircle from 'react-ionicons/lib/CloseCircle'


export default function Card({ children,text,color,title,comingSoon=false,dark=false}) {
 const [open,setOpen] = useState(false)
  return (
    <div className={`flip-card ${open&&"open"}`}  onClick={()=>{setOpen(!open)}}>
    <div className="flip-card-inner">
      <div className="flip-card-front" style={{background:color}}>
        <div>
        {children}
        </div>
      

       
                <ArrowForwardCircle
  color={dark?'#0b0b0b':'#fff'} 
  height="50px"
  width="50px"
  className={"clickable"}
  style={{position:"absolute",bottom:20,right:20}}
/>

      </div>
      <div className="flip-card-back p-10">
        <h2 className="text-left pb-3 sectionh5">{title}</h2>
       <textarea value={text} className='text-back' readOnly  width="100%" height="100%"></textarea>
      {comingSoon&&<button className="tag">Coming Soon</button>}
                <CloseCircle
  height="50px"
  width="50px"
  cssClasses={"clickable"}
  style={{position:"absolute",bottom:20,right:20}}
/>
      </div>
    </div>
  </div>
  )
}
